var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.625C7.5 10.625 7.125 11.0312 7.125 11.5C7.125 12 7.5 12.375 8 12.375C8.46875 12.375 8.875 12 8.875 11.5C8.875 11.0312 8.46875 10.625 8 10.625ZM8.21875 9.875C8.4375 9.875 8.59375 9.71875 8.59375 9.5C8.59375 8.15625 11.0312 8.25 11.0312 6.15625C11.0312 4.5625 9.59375 3.625 7.96875 3.625C6.5625 3.625 5.78125 4.1875 5.125 5.03125C5 5.21875 5.03125 5.4375 5.21875 5.5625L5.625 5.875C5.78125 5.96875 6 5.9375 6.125 5.78125C6.59375 5.1875 7.0625 4.875 7.96875 4.875C9.21875 4.875 9.78125 5.53125 9.78125 6.15625C9.78125 7.5 7.34375 7.3125 7.34375 9.5C7.34375 9.71875 7.53125 9.875 7.71875 9.875H8.21875ZM8 1.25C11.6875 1.25 14.75 4.28125 14.75 8C14.75 11.75 11.7188 14.75 8 14.75C4.25 14.75 1.25 11.75 1.25 8C1.25 4.28125 4.25 1.25 8 1.25ZM8 0.25C3.71875 0.25 0.25 3.75 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.25 15.75 15.75 12.2812 15.75 8C15.75 3.75 12.25 0.25 8 0.25Z",
    fill: "#E8BE04"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.55e19a62.svg";
export { ForwardRef as ReactComponent };